import type { RSVP } from "./rsvp";

export interface Role {
    name: string;
    description: string;
    objectId: string;
    passport_number: string;
    nationality: string;
    date_of_birth: string;
    character_sheet_url: string;
    relationships: string[];
    character_info: string;
    group?: string | null;
    group_number?: number | null;
    /** Spoiler-free label, e.g. "Group A Role #1". */
    anonymous_display?: string;
}

/** Role as returned by GET /games/roles?game_id= — includes assignment state. */
export interface GameRole extends Role {
    anonymous_display: string;
    assigned_player_id: string | null;
}

export interface Mystery {
    objectId: string;
    name: string;
    description: string;
    number_of_players?: number;
    number_of_rounds?: number;
    intro_text: string;
    image_url: string;
    roles: Role[];
}


export interface Player {
    objectId: string;
    name: string;
    role: Role;
    phone_number: string;
    email: string;
    interrogation_tokens: number;
    email_sent: boolean;
    attendance: boolean;
    round_updates: string[];
}

export enum GameState {
    INVITING = "inviting",
    INVITES_CLOSED = "invites_closed",
    PRE_GAME = "pre_game",
    IN_PROGRESS = "in_progress",
}

export interface GameHost {
    first_name?: string;
    last_name?: string;
}

/** Authenticated user's player/character on this game (from GET /games/games). */
export interface MyCharacter {
    objectId: string;
    name: string;
    attendance: boolean;
    access_code: string | null;
    role: Pick<
        Role,
        | "name"
        | "description"
        | "objectId"
        | "character_sheet_url"
        | "relationships"
        | "character_info"
        | "passport_number"
        | "nationality"
        | "date_of_birth"
    > | null;
}

export interface Game {
    objectId: string;
    name: string;
    game_state: GameState;
    current_round: number;
    mystery: Mystery;
    players: Player[];
    host?: GameHost | null;
    rsvp: RSVP | null;
    is_host?: boolean;
    /** Whether the host is playing a character (they always administer). */
    host_is_playing?: boolean;
    my_character?: MyCharacter | null;
}